export function getInfoList(lists) {
	let result = "";
	lists.forEach(config => {
		result += "<div class='webix_um_infolist_header'>";
		if (config.icon)
			result += `<span class='webix_icon ${config.icon}'></span>`;
		result += `${config.title} (${config.data.length})</div>`;
		result += "<ul class='webix_um_infolist'>";
		config.data.forEach(record => {
			result += `<li class='webix_um_infolist_${config.name}_item' data-id='${record.id}'>`;
			result += `<span class='webix_um_infolist_name webix_um_infolist_${
				config.name
			}_name'>${record[config.key]}</span>`;
			if (config.deleteIcon)
				result += `<span class='webix_um_infolist_${config.name}_delete webix_icon wxi-close'></span>`;
			result += "</li>";
		});
		result += "</ul>";
	});
	return result;
}
